/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 * Auth ServiceAccess actions
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.11.0
 */

import { createAction } from '@modules/app/createAction';

import {
    CHANGE_USER_SERVICE_ACCESS,
    LOGIN_PROCESS_NEWS_SERVICE_ACCESS_ERROR,
    LOGIN_PROCESS_NEWS_SERVICE_ACCESS_SUCCESSFUL,
    LOGIN_PROCESS_SERVICE_ACCESS,
    LOGIN_PROCESS_SERVICE_ACCESS_ERROR,
    LOGIN_PROCESS_SERVICE_ACCESS_SUCCESSFUL,
    LOGIN_USER_SERVICE_ACCESS,
} from '../constants/authServiceAccessConstants';
import {
    ILoginServiceAccessPayload,
    TChangeUserServiceAccessAction,
    TLoginProcessNewsServiceAccessErrorAction,
    TLoginProcessNewsServiceAccessSuccessfulAction,
    TLoginProcessServiceAccessAction,
    TLoginProcessServiceAccessErrorAction,
    TLoginProcessServiceAccessSuccessfulAction,
    TLoginUserServiceAccessAction,
} from '../types/authServiceAccessTypes';
import { ILoginProcessRequest } from '../types/authTypes';

/*
 * -------------------------------------------
 *         Логин Пользователя как СП
 * -------------------------------------------
 */

export const loginProcessServiceAccessAction = (payload: ILoginProcessRequest): TLoginProcessServiceAccessAction =>
    createAction(LOGIN_PROCESS_SERVICE_ACCESS, payload);

export const loginProcessServiceAccessSuccessfulAction = (): TLoginProcessServiceAccessSuccessfulAction =>
    createAction(LOGIN_PROCESS_SERVICE_ACCESS_SUCCESSFUL);

export const loginProcessServiceAccessErrorAction = (): TLoginProcessServiceAccessErrorAction =>
    createAction(LOGIN_PROCESS_SERVICE_ACCESS_ERROR);

/*
 * -------------------------------------------
 *         Логин Пользователя как СП для новостей
 * -------------------------------------------
 */

export const loginProcessNewsServiceAccessSuccessfulAction = (): TLoginProcessNewsServiceAccessSuccessfulAction =>
    createAction(LOGIN_PROCESS_NEWS_SERVICE_ACCESS_SUCCESSFUL);

export const loginProcessNewsServiceAccessErrorAction = (): TLoginProcessNewsServiceAccessErrorAction =>
    createAction(LOGIN_PROCESS_NEWS_SERVICE_ACCESS_ERROR);

/*
 * -------------------------------------------
 *     Логин СП Пользователя как абонента
 * -------------------------------------------
 */

export const loginUserServiceAccessAction = (payload: ILoginServiceAccessPayload): TLoginUserServiceAccessAction =>
    createAction(LOGIN_USER_SERVICE_ACCESS, payload);

/*
 * -------------------------------------------
 *   Сменить пользователя (сессия СП остается)
 * -------------------------------------------
 */

export const changeUserServiceAccessAction = (): TChangeUserServiceAccessAction =>
    createAction(CHANGE_USER_SERVICE_ACCESS);
